import React, { memo } from 'react';
import DynamicIcon from './DynamicIcon';

const Breadcrumbs = memo(({ items, darkMode, onClick }) => (
  <nav aria-label="breadcrumb" className="flex items-center text-sm flex-wrap">
    {items.map((bc, index) => (
      <div key={bc.key} className="flex items-center">
        <button
          onClick={() => onClick(index)}
          disabled={index === items.length - 1}
          aria-current={index === items.length - 1 ? 'page' : undefined}
          aria-label={`Go to ${bc.name}`}
          className={`py-1 px-2.5 rounded-lg transition-all font-medium ${
            index === items.length - 1 
              ? 'text-white bg-white/20 cursor-default' 
              : `text-slate-200 hover:bg-white/20`
          }`}
        >
          {bc.name}
        </button>
        {index < items.length - 1 && (
          <DynamicIcon name="chevronRight" darkMode={darkMode} className="h-4 w-4 mx-1" />
        )}
      </div>
    ))}
  </nav>
));

export default Breadcrumbs;